export const TableRegex = {
  CHECK_ICON: /:checkIcon\(([^,]+)(?:,\s*(.*))?\):/, //example of usage :checkIcon(blue): OR :checkIcon(blue, Some text):
  CHECK_ICON_BLACK_STROKE: /:checkIconBlackStroke\(([^,]+)(?:,\s*(.*))?\):/, // example of usage :checkIconBlackStroke(white): OR :checkIconBlackStroke(white, Some text):
  DASH_ICON: /:dashIcon\(([^,]+)\):/, // example of usage :dashIcon(blue):
  CROSS_ICON: /:crossIcon:/, //example of usage :crossIcon:
  TITLE: /:title\((.*?)\):/, //example usage: :title(Card Machine Comparison):
  PRICE: /:price\((.*?)\):/, //example usage: :price(R899):
  PRICE_FROM_STORYBLOK_SLUG: /:priceFromStoryblokSlug\((.*?)\):/, //example usage: :priceFromStoryblokSlug(settings/products/yoco-go):
  DETAILED_PRICE_FROM_STORYBLOK_SLUG:
    /:detailedPriceFromStoryblokSlug\((.*?)(?:,\s*(.*?))?\):/, //example usage: :detailedPriceFromStoryblokSlug(settings/products/yoco-go, optional superscript):
  BUTTON: /:button\((.*?)\):/, //example usage: :button(get started,www.yoco.com/za):
  HEADER: /:header\((.*?)\):/, //example usage: :header(Card Machine Comparison):
  LIST: /:list\(([^,]+)(,[^,]+)*\):/,
  BULLET: /:bullet\(([^,]+)(,[^,]+)*\):/, //example usage: :bullet(item 1, item 2, item 3):
  PRODUCT: /:product\(([^,]+),\s*(.*?)\):/, //example usage: :product(productName, description):
}
